const partners = [
  {
    name: 'Digifort',
    abbr: 'DF',
    description: 'Plataforma de gerenciamento de vídeo (VMS) líder no mercado nacional.',
    logo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/790e28d2-b227-4798-b38e-a11c0ab1fe97_digifort.png?v=96b983b53d7112e07ed9dfd382424061',
  },
  {
    name: 'Hikvision',
    abbr: 'HK',
    description: 'Líder mundial em soluções inovadoras de segurança eletrônica e videomonitoramento.',
    logo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/26e1f03f-5caf-490f-af51-95291e037b93_hikvision.png?v=35d065d8877fed087b28724891af7d1a',
  },
  {
    name: 'Insof4',
    abbr: 'I4',
    description: 'Soluções em software de controle de acesso e gestão de segurança para empresas.',
    logo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/3e11d6cd-77d5-44f6-85dd-bcfa6b30f83d_insofr4.png?v=1a5eebc7dbd707aee86b84a38e00c84c',
  },
  {
    name: 'Aeroguard',
    abbr: 'AG',
    description: 'Operação de locação de drones autônomos para monitoramento aéreo e segurança inteligente.',
    logo: 'https://storage.readdy-site.link/project_files/55d2414d-b0d8-48ff-97d2-b36c2fb1f46c/8228006d-30b1-4e2c-a420-5e704072a622_aeroguard.jpg?v=9f492011b05b4c11f78186f78ce31a0d',
  },
];

function PartnerCard({ partner }: { partner: typeof partners[0] }) {
  return (
    <div className="group border border-neutral-200 rounded-2xl p-8 flex flex-col items-center text-center hover:border-red-300 hover:bg-red-50/20 transition-all duration-300 cursor-default">
      <div className="w-40 h-20 flex items-center justify-center mb-6">
        <img
          src={partner.logo}
          alt={`Logo ${partner.name}`}
          className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
        />
      </div>
      <h3 className="font-bold text-neutral-800 text-lg mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
        {partner.name}
      </h3>
      <p className="text-neutral-500 text-sm leading-relaxed">{partner.description}</p>
    </div>
  );
}

export default function Partners() {
  return (
    <section id="partners" className="py-28 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="max-w-2xl mx-auto text-center mb-16">
          <span className="inline-block text-red-600 text-xs font-bold uppercase tracking-widest bg-red-50 px-3 py-1.5 rounded-full mb-6">
            / Parceiros Tecnológicos
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-neutral-900 mb-5 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Trabalhamos com as{' '}
            <span className="text-red-600">Melhores Marcas</span>
          </h2>
          <p className="text-neutral-500 text-base leading-relaxed">
            Nossas soluções são sustentadas por parcerias estratégicas com as principais marcas do
            mercado de segurança eletrônica, garantindo qualidade e confiabilidade em cada projeto.
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {partners.map((partner) => (
            <PartnerCard key={partner.name} partner={partner} />
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-14 rounded-2xl overflow-hidden relative">
          <div className="absolute inset-0 bg-gradient-to-r from-neutral-900 via-red-900 to-neutral-900"></div>
          <div className="relative z-10 px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <div>
              <p className="text-white font-bold text-xl mb-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Tecnologia de ponta aplicada à sua segurança
              </p>
              <p className="text-neutral-300 text-sm">
                Integramos as melhores soluções do mercado para proteger o que é mais importante para você.
              </p>
            </div>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-2 bg-red-600 hover:bg-red-500 text-white px-7 py-3 rounded-xl text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Saiba Mais
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
